import { LegalPage, LegalSection } from "./Legal";

const Privacy = () => (
  <LegalPage
    eyebrow="Legal"
    title={<>Privacy <span className="text-gradient">Policy</span></>}
    description="How Cloudease collects, uses, and protects information when you engage with our website and services."
    seoTitle="Privacy Policy — Cloudease"
    seoDescription="Learn how Cloudease collects, uses, and safeguards personal information across our website, contact forms, and consulting engagements."
    path="/privacy"
    updated="April 2026"
  >
    <LegalSection title="1. Who we are">
      <p>Cloudease Technologies ("Cloudease", "we", "us") is a cloud, DevOps, and platform-engineering consultancy headquartered in Bengaluru, India. This policy explains how we handle personal data collected via cloudease.in and during customer engagements.</p>
    </LegalSection>
    <LegalSection title="2. Information we collect">
      <p>We collect information that you provide directly — such as name, work email, phone number, company, and the message you share via our contact form or AI concierge. When you browse the site, we also log limited technical data such as IP address, approximate city/country, referring page, and pages visited.</p>
    </LegalSection>
    <LegalSection title="3. How we use information">
      <p>We use the information to respond to inquiries, deliver contracted services, improve the site, prevent abuse, and — where permitted — send occasional updates about Cloudease. We do not sell personal data.</p>
    </LegalSection>
    <LegalSection title="4. Legal bases">
      <p>Where applicable law requires a legal basis (e.g., GDPR), we rely on: your consent, our legitimate interest in operating the business, performance of a contract, or compliance with legal obligations.</p>
    </LegalSection>
    <LegalSection title="5. Sharing and subprocessors">
      <p>We share data only with vetted subprocessors that support our operations — including cloud hosting, database, email delivery, and analytics providers. Each is bound by contract to protect your data. Customer production data remains inside the customer's own cloud accounts.</p>
    </LegalSection>
    <LegalSection title="6. Retention">
      <p>Contact-form submissions are retained for as long as needed to respond and, where relevant, maintain a customer relationship. Website analytics are retained in aggregate. You can request deletion at any time.</p>
    </LegalSection>
    <LegalSection title="7. Your rights">
      <p>Depending on your jurisdiction, you may have rights to access, correct, export, or delete your personal data, and to object to certain processing. Email <a className="text-primary hover:underline" href="mailto:hello@cloudease.in">hello@cloudease.in</a> to exercise any of these rights.</p>
    </LegalSection>
    <LegalSection title="8. Security">
      <p>We follow the same security practices we recommend to our customers — least-privilege access, encryption in transit and at rest, audit logging, and MFA on administrative accounts. See our <a className="text-primary hover:underline" href="/security">Security</a> page for details.</p>
    </LegalSection>
    <LegalSection title="9. Contact">
      <p>Questions about this policy? Reach us at <a className="text-primary hover:underline" href="mailto:hello@cloudease.in">hello@cloudease.in</a> or +91 87787 30675.</p>
    </LegalSection>
  </LegalPage>
);

export default Privacy;
